module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DB79_1SB_G9K.c7b528d2.png";